var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.812 18.003c.932 0 1.688-.755 1.688-1.687V4.641c0-.447-.18-.88-.496-1.196l-2.95-2.95A1.7 1.7 0 0 0 8.864 0H1.687A1.693 1.693 0 0 0 0 1.691v14.625c0 .932.756 1.687 1.687 1.687zm0-1.687H1.687V1.691h5.625v3.656c0 .468.377.844.844.844h3.656zm-.137-11.813H9V1.828z"
  })));
};
export default SvgFile;